import React, { Component } from 'react';
import { appActions } from 'state/modules/app';
import btnStyles from 'styles/partials/_button.css';
import componentStyles from 'styles/partials/_loginmodal.css';
import styled from 'styled-components';

const ErrorMsg = styled.div`
  text-align: center;
  margin: 1em 0;
  color: #aaa;
`;

export default class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.checkCapsLock = this.checkCapsLock.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.state = {
      username: props.userName,
      password: '',
      capsLock: false,
      errorMsg: null,
    };
    this.styles = {};
    Object.assign(this.styles, componentStyles, btnStyles);

    this.usernameRef = React.createRef();
    this.passwordRef = React.createRef();
    this.submitRef = React.createRef();
  }

  componentDidMount() {
    this.passwordRef.current.focus();
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  checkCapsLock(event) {
    if (event.key === 'Enter') return;

    if (/[a-zA-Z]/.test(event.key) && event.key === event.key.toUpperCase() && !event.shiftKey) {
      this.setState({ capsLock: true });
    } else {
      this.setState({ capsLock: false });
    }
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      errorMsg: null,
    });

    const username = this.state.username;
    const password = this.state.password;

    if (!username || !password) {
      return;
    }

    this.submitRef.current.blur();
    this.submitRef.current.setAttribute('disabled', 'true');
    Promise.resolve(
      this.props.dispatch(appActions.loginRequestModal(username, password, this.props.currentCompany))
    ).then(response => {
      if (response.error) {
        this.setState({
          errorMsg: response.error,
        });
        this.submitRef.current.removeAttribute('disabled');
      }
    });
  }

  render() {
    let capsLockWarn = null;

    return (
      <div className={this.styles['containerBackground']}>
        <div className={this.styles['container']}>
          {capsLockWarn}
          <div className={this.styles['loginForm']}>
            <form onSubmit={this.handleLogin.bind(this)}>
              <h3 className={this.styles['heading']}>
                Profit4 <span className={this.styles['headingAlt']}>session timeout</span>
              </h3>
              <input
                type="text"
                ref={this.usernameRef}
                value={this.state.username}
                className={this.styles['input']}
                aria-describedby="sizing-addon1"
                autoFocus={true}
                placeholder="Username"
              />
              <input
                type="password"
                ref={this.passwordRef}
                onChange={this.handlePasswordChange.bind(this)}
                onKeyPress={this.checkCapsLock}
                value={this.state.password}
                className={this.styles['input']}
                aria-describedby="sizing-addon1"
                placeholder="Password"
              />
              <button ref={this.submitRef} type="submit" data-testid="login-submit" className={this.styles['loginBtn']}>
                <i
                  style={{
                    paddingRight: 5 + 'px',
                    lineHeight: 'inherit',
                    verticalAlign: 'bottom',
                  }}
                  className="iconSmall"
                  aria-hidden="true"
                >
                  lock
                </i>
                Login
              </button>
            </form>
            {this.state.capsLock ? <ErrorMsg>Caps lock may be on</ErrorMsg> : null}
            {this.state.errorMsg ? <ErrorMsg>{this.state.errorMsg}</ErrorMsg> : null}
          </div>
        </div>
      </div>
    );
  }
}
